import { gql, useQuery } from "@apollo/client";
import { Dayjs } from "dayjs";
import { TeacherTier } from "./teacherTiers.ts";

const GetTeacherWeekAssignmentCapQuery = gql`
  query getTeacherWeekAssignmentCap($teacherId: String!, $weekDate: String!) {
    getTeacherWeekAssignmentCap(teacherId: $teacherId, weekDate: $weekDate) {
      weekStartUtc
      weekEndUtc
      offeredSlots
      assignedClassRooms
      weeklyCapWithCurrentTier {
        tier
        maxPercentOfWeeklyAvailability
        maxAssignableClassRooms
        hasBeenReached
      }
    }
  }
`;

export type WeeklyCapWithCurrentTier = {
  tier: TeacherTier;
  maxPercentOfWeeklyAvailability: number;
  maxAssignableClassRooms: number;
  hasBeenReached: boolean;
};

export type TeacherWeekAssignmentCap = {
  weekStartUtc: string;
  weekEndUtc: string;
  offeredSlots: number;
  assignedClassRooms: number;
  weeklyCapWithCurrentTier: WeeklyCapWithCurrentTier | null;
};

type QueryResult = {
  getTeacherWeekAssignmentCap: TeacherWeekAssignmentCap;
};

export function useTeacherWeekAssignmentCap({
  teacherId,
  weekStart,
}: {
  teacherId: string;
  weekStart: Dayjs;
}) {
  const { data, loading } = useQuery<QueryResult>(
    GetTeacherWeekAssignmentCapQuery,
    {
      variables: { teacherId, weekDate: weekStart.toISOString() },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    weekAssignmentCap: data?.getTeacherWeekAssignmentCap ?? null,
    loading: loading && !data,
  };
}
